var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.useDismissedPlacementTabExplanation)?_c('ProjectMenuTabsExplanation',{on:{"dismiss":_vm.onDismiss}},[_c('h5',[_vm._v("Placements lets you create and manage features based on where they are used")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }